import { BorderColorOutlined, CallSplit } from "@mui/icons-material";
import { FC, RefObject } from "react";
import { useTranslation } from "react-i18next";

interface IRideStationBulkActionsMenuProps {
  isMovePassengersAllowed: boolean;
  updateStationsButtonRef: RefObject<HTMLButtonElement>;
  movePassengersButtonRef: RefObject<HTMLButtonElement>;
  onUpdateStationsClick: () => void;
  onMovePassengersClick: () => void;
}

export const RideStationBulkActionsMenu: FC<
  IRideStationBulkActionsMenuProps
> = ({
  isMovePassengersAllowed,
  updateStationsButtonRef,
  movePassengersButtonRef,
  onUpdateStationsClick,
  onMovePassengersClick,
}) => {
  const { t } = useTranslation();

  return (
    <nav className="bulk_actions_menu">
      <button
        ref={updateStationsButtonRef}
        type="button"
        className="bulk_menu_item"
        onClick={onUpdateStationsClick}
      >
        <BorderColorOutlined className="bulk_menu_item_icon" />
        {t("ride.BULK_ACTION_UPDATE_STATIONS")}
      </button>
      {isMovePassengersAllowed && (
        <button
          ref={movePassengersButtonRef}
          type="button"
          className="bulk_menu_item"
          onClick={onMovePassengersClick}
        >
          <CallSplit className="bulk_menu_item_icon" />
          {t("ride.BULK_ACTION_MOVE_PASSENGERS")}
        </button>
      )}
    </nav>
  );
};
